<template>
  <div
    class="bg-grey-lightest md:border-t md:mb-8
    md:border-border-color"
  >
    <div
      :class="{
        'bg-else': !opportunityBackground,
        'bg-opportunity': opportunityBackground,
      }"
      class="bg-custom md:pt-15 md:pb-6 bg-no-repeat bg-contain md:max-w-2xl m-auto"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheBackgroundHeader',
  props: {
    opportunityBackground: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-custom {
  background-position: right -15% bottom 0;

  @media (min-width: 576px) {
    background-position: right 15% bottom 0;
  }

  @media (min-width: 768px) {
    background-position: right;
  }
}

.bg-else {
  background-image: url('../assets/investments-bg.svg');
}
.bg-opportunity {
  background-image: url('../assets/opportunities-bg.svg');
  background-position: right -7% bottom 0;
  @media (min-width: 576px) {
    background-position: right 15% bottom 0;
  }
  @media (min-width: 768px) {
    background-position: right;
  }
}
</style>
